export default {
    description: {
        booked_by: 'Booked by',
        booked_to: 'to',
    },
    link_to_reservation: 'Url to reservation',
}
